import { data } from '../../svg/Task/data';
import { makeIcon } from '../makeIcon';

export const Task = makeIcon(data, 'task', 'Task');

export default Task;
